var _rect, _path, _circle, _text, _rect2, _text2, _text3, _circle2, _text4, _rect3, _text5, _text6, _circle3, _text7, _rect4, _text8, _text9, _circle4, _text0, _rect5, _text1, _text10, _circle5, _text11, _rect6, _text12, _text13, _circle6, _text14, _rect7, _text15, _text16, _rect8, _text17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreAccountabilityLoopMobileSequence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 360,
    height: 680,
    viewBox: "0 0 360 680",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FleetCore accountability loop mobile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 358,
    height: 678,
    rx: 24,
    fill: "#FFFFFF",
    stroke: "#C8D9ED",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 72V586",
    stroke: "#9BCFFF",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 72,
    r: 23,
    fill: "#EDF6FF",
    stroke: "#087CFF",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 76,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 800
  }, "01")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 42,
    width: 237,
    height: 60,
    rx: 13,
    fill: "#F8FBFF",
    stroke: "#087CFF",
    strokeOpacity: 0.32
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 68,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 800
  }, "Driver")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 88,
    fill: "#61758F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Identity and credentials")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 166,
    r: 23,
    fill: "#FFF1F6",
    stroke: "#FF2775",
    strokeWidth: 2
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 170,
    textAnchor: "middle",
    fill: "#FF2775",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 800
  }, "02")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 136,
    width: 237,
    height: 60,
    rx: 13,
    fill: "#F8FBFF",
    stroke: "#FF2775",
    strokeOpacity: 0.32
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 162,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 800
  }, "Vehicle")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 182,
    fill: "#61758F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Registration and baseline")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 260,
    r: 23,
    fill: "#EDF6FF",
    stroke: "#087CFF",
    strokeWidth: 2
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 264,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 800
  }, "03")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 230,
    width: 237,
    height: 60,
    rx: 13,
    fill: "#F8FBFF",
    stroke: "#087CFF",
    strokeOpacity: 0.32
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 256,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 800
  }, "Shift")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 276,
    fill: "#61758F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Check-in and check-out")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 354,
    r: 23,
    fill: "#FFF1F6",
    stroke: "#FF2775",
    strokeWidth: 2
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 358,
    textAnchor: "middle",
    fill: "#FF2775",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 800
  }, "04")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 324,
    width: 237,
    height: 60,
    rx: 13,
    fill: "#F8FBFF",
    stroke: "#FF2775",
    strokeOpacity: 0.32
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 350,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 800
  }, "Fuel")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 370,
    fill: "#61758F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Litres and readings")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 448,
    r: 23,
    fill: "#EDF6FF",
    stroke: "#087CFF",
    strokeWidth: 2
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 452,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 800
  }, "05")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 418,
    width: 237,
    height: 60,
    rx: 13,
    fill: "#F8FBFF",
    stroke: "#087CFF",
    strokeOpacity: 0.32
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 444,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 800
  }, "Intelligence")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 464,
    fill: "#61758F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Expected versus actual")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 542,
    r: 23,
    fill: "#FFF1F6",
    stroke: "#FF2775",
    strokeWidth: 2
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 546,
    textAnchor: "middle",
    fill: "#FF2775",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 800
  }, "06")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 512,
    width: 237,
    height: 60,
    rx: 13,
    fill: "#F8FBFF",
    stroke: "#FF2775",
    strokeOpacity: 0.32
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 538,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 800
  }, "Action")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 558,
    fill: "#61758F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Exception reviewed")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 624,
    width: 304,
    height: 34,
    rx: 17,
    fill: "#07152A"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 646,
    textAnchor: "middle",
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5,
    fontWeight: 730
  }, "ONE CONNECTED OPERATIONAL EVENT")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreAccountabilityLoopMobileSequence);
export default __webpack_public_path__ + "static/media/fleetcore-accountability-loop-mobile-sequence.3aa4406ba4596a779536059d8e0b6cdb.svg";
export { ForwardRef as ReactComponent };